import { cn } from '@/lib/utils'
import { toneVar, type DsTone } from '@/ds/tone'

export interface DsSpinnerProps {
  size?: number
  tone?: DsTone
  /** Use the surrounding text colour (inside a button). */
  inherit?: boolean
  semanticLabel?: string
  className?: string
}

export function DsSpinner({ size = 20, tone = 'brand', inherit, semanticLabel = 'Loading', className }: DsSpinnerProps) {
  const stroke = size > 20 ? 3 : 2
  const r = (size - stroke) / 2
  const c = 2 * Math.PI * r
  return (
    <svg
      role="status"
      aria-label={semanticLabel}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={cn('animate-ds-spin shrink-0', className)}
      style={{ color: inherit ? 'currentColor' : toneVar(tone, 'solid') }}
    >
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeOpacity={0.2} strokeWidth={stroke} />
      <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="currentColor" strokeWidth={stroke} strokeLinecap="round" strokeDasharray={`${c * 0.28} ${c}`} />
    </svg>
  )
}
